<template>
  <component :is="currentComponent" :key="componentKey" />
</template>

<script>
import WrongAnalysis from './WrongAnalysis.vue'
import WrongAnalysisMobile from './WrongAnalysisMobile.vue'
import { isMobile, addResizeListener } from '@/utils/device'

export default {
  name: 'WrongAnalysisIndex',
  data() {
    return {
      isMobileDevice: false,
      removeResizeListener: null,
      componentKey: 'init'
    }
  },
  computed: {
    currentComponent() {
      return this.isMobileDevice ? WrongAnalysisMobile : WrongAnalysis
    }
  },
  created() {
    this.isMobileDevice = isMobile()
  },
  mounted() {
    let rafId = null
    const onResize = () => {
      if (rafId) return
      rafId = requestAnimationFrame(() => {
        const next = isMobile()
        if (next !== this.isMobileDevice) {
          this.isMobileDevice = next
          this.componentKey = next ? 'm' : 'pc'
        }
        rafId = null
      })
    }
    this.removeResizeListener = addResizeListener(onResize)
  },
  beforeDestroy() {
    if (this.removeResizeListener) {
      this.removeResizeListener()
      this.removeResizeListener = null
    }
  }
}
</script>

<style scoped>
</style>